import { render, staticRenderFns } from "./Results-match.vue?vue&type=template&id=32ca5b29"
import script from "./Results-match.vue?vue&type=script&lang=js"
export * from "./Results-match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports